import service from "./service"

const companyBillingStatusQuery = async () => {
    return service()
}

export default companyBillingStatusQuery
